import { SessionData } from '@pickleballinc/lib/session';
import { Url } from 'next/dist/shared/lib/router/router';
import { useEffect, useState } from 'react';

import { publicEnv } from '@/lib/env';
import { GetPBApproveToCreatePermissionRes } from '@/utils/actions/leagues/getPBApproveToCreatePermission';
import { getLoginUrl } from '@/utils/helpers/getLoginUrl';
import isValidURL from '@/utils/helpers/isValidURL';

export const useCreateTournamentURL = (
  session: SessionData | undefined,
  createPerms: GetPBApproveToCreatePermissionRes | null | undefined,
  ssoRedirectUrl?: string
) => {
  const [createATournamentURL, setCreateATournamentURL] = useState<Url>('');

  useEffect(() => {
    const continueUrl =
      ssoRedirectUrl?.trim() || (typeof window !== 'undefined' ? window.location.href : '');

    if (!continueUrl) return;

    if (!session?.user?.uuid) {
      setCreateATournamentURL(getLoginUrl(continueUrl));
      return;
    }

    if (createPerms?.ApprovedToCreate && createPerms.URLPath) {
      if (isValidURL(createPerms.URLPath)) {
        const url = new URL(createPerms.URLPath);
        url.searchParams.set('rurl', continueUrl);
        setCreateATournamentURL(url);
      } else {
        const url = new URL(`${publicEnv.NEXT_PUBLIC_PBRACKETS_URL}/${createPerms.URLPath}`);
        url.searchParams.set('rurl', continueUrl);
        setCreateATournamentURL(url);
      }
    } else {
      const url = new URL(publicEnv.NEXT_PUBLIC_CONTACT_FORM_URL);
      url.pathname += 'contacts/tournament/create';
      setCreateATournamentURL(url);
    }
  }, [session, createPerms, ssoRedirectUrl]);

  return createATournamentURL;
};
